/* Murphy Bundle – consolidated JS
   - Style chooser modal (open/close)
   - Variant image swap + price update
   - Add bundle (bed + gifts) → go straight to Checkout (with discount)
   - Floating CTA hide on scroll
   - 3-step portrait slider (auto-rotate + progress bar)
*/
(() => {
  const section = document.querySelector('.murphy-bundle');
  if (!section) return;

  // ----- Data from section -----
  const discount = section.dataset.discount || '';
  const giftMattress = section.dataset.giftMattress ? Number(section.dataset.giftMattress) : null;
  const giftWarranty = section.dataset.giftWarranty ? Number(section.dataset.giftWarranty) : null;
  const giftDelivery = section.dataset.giftDelivery ? Number(section.dataset.giftDelivery) : null;

  // ===== Style chooser modal =====
  const modal = section.querySelector('.style-modal');
  const openBtns = section.querySelectorAll('.js-open-style-chooser');
  const closeBtn = section.querySelector('.js-close-style-chooser');

  const productCache = {};

  const money = (cents) => {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        const fmt = (window.theme && theme.moneyFormat) ? theme.moneyFormat : "${{amount}}";
        return Shopify.formatMoney(cents, fmt);
      }
    } catch(e){}
    return "$" + (cents/100).toFixed(2);
  };

  async function fetchProduct(handle){
    if (productCache[handle]) return productCache[handle];
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error('Product fetch failed: ' + handle);
    const data = await res.json();
    productCache[handle] = data;
    return data;
  }

  function findVariant(product, id){
    const n = Number(id);
    return product.variants.find(v => Number(v.id) === n) || product.variants[0];
  }

  function swapImage(card, variant, product){
    const imgEl = card.querySelector('.style-card__media img');
    if (!imgEl) return;
    const src = (variant && variant.featured_image && variant.featured_image.src)
              || (product && product.featured_image)
              || null;
    if (src){
      // strip Shopify params to avoid wrong sizing
      imgEl.src = src.replace(/(\.jpg|\.jpeg|\.png|\.webp)(\?.*)?$/i, '$1');
      imgEl.srcset = '';
    }
  }

  function updatePrice(card, variant){
    const priceEl = card.querySelector('.style-card__price');
    if (priceEl && variant && typeof variant.price === 'number') {
      priceEl.textContent = money(variant.price);
    }
  }

  function getVariantSelectEl(card){
    const el = card.querySelector('.js-variant-select');
    return el || null; // could be <select> or hidden <input>
  }

  function initCard(card){
    const handle = card.dataset.productHandle;
    if (!handle) return;

    fetchProduct(handle).then(product => {
      const sel = getVariantSelectEl(card);

      // Tidy "Default Title" if present
      if (sel && sel.tagName === 'SELECT') {
        Array.from(sel.options).forEach(opt => {
          if (opt.text === 'Default Title') opt.text = 'Standard';
        });
      } else {
        const label = card.querySelector('.style-card__single-variant');
        if (label && label.textContent.trim() === 'Default Title') label.remove();
      }

      const currentId = Number(sel ? sel.value : (product.variants[0] && product.variants[0].id));
      const variant = findVariant(product, currentId);
      swapImage(card, variant, product);
      updatePrice(card, variant);

      if (sel && sel.tagName === 'SELECT') {
        sel.addEventListener('change', (e) => {
          const v = findVariant(product, Number(e.currentTarget.value));
          swapImage(card, v, product);
          updatePrice(card, v);
        });
      }

      card.__product = product;
    }).catch(()=>{ /* ignore */ });
  }

  function initModal(){
    if (!modal) return;
    modal.querySelectorAll('.style-card').forEach(initCard);
  }

  // Open / close modal
  openBtns.forEach(btn => btn.addEventListener('click', () => {
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('no-scroll');
    initModal();
  }));
  closeBtn && closeBtn.addEventListener('click', () => {
    modal.hidden = true;
    document.documentElement.classList.remove('no-scroll');
  });
  modal && modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.hidden = true;
      document.documentElement.classList.remove('no-scroll');
    }
  });

  // Add bundle then go straight to Checkout (with discount)
  async function addBundleAndCheckout(variantId){
    const items = [];
    if (variantId) items.push({ id: Number(variantId), quantity: 1 });
    // Free bundle items are auto-added by aff-bundle-gifts.js

    if (!items.length) return;

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });

    let url = '/cart';
    if (discount) url += '?discount=' + encodeURIComponent(discount);
    window.location.href = url;
  }

  // Handle "Select" clicks inside modal
  modal && modal.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-add-bundle');
    if (!btn) return;
    const card = btn.closest('.style-card');
    const sel = getVariantSelectEl(card);
    const variantId = sel ? sel.value : null;
    addBundleAndCheckout(variantId);
  });

  // ===== Floating CTA: hide on scroll down, show on scroll up =====
  const ctaBar = section.querySelector('.bundle-bar');
  if (ctaBar){
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > lastY + 8)      ctaBar.classList.add('bundle-bar--hide');   // scrolling down
      else if (y < lastY - 8) ctaBar.classList.remove('bundle-bar--hide'); // scrolling up
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ===== 3-step portrait slider (auto-rotate + vertical progress) =====
  const tri = section.querySelector('.tri-steps');
  if (tri){
    // Accent color + rotate interval from data attributes
    const accent = tri.dataset.accent || '#10b981';
    tri.style.setProperty('--accent', accent);
    let ms = parseInt(tri.dataset.rotate || '4000', 10);
    if (isNaN(ms) || ms < 2000) ms = 4000;

    const frames = Array.from(tri.querySelectorAll('.tri-frame'));
    const steps  = Array.from(tri.querySelectorAll('.tri-step'));
    let idx = 0, timer = null;

    const activate = (i) => {
      idx = (i + frames.length) % frames.length;
      frames.forEach((f, j) => f.classList.toggle('is-active', j === idx));
      steps.forEach((s, j) => {
        const on = j === idx;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-selected', on ? 'true' : 'false');
        const prog = s.querySelector('.tri-progress');
        if (prog){
          // restart progress animation
          prog.style.animation = 'none';
          void prog.offsetHeight; // reflow
          prog.style.animation = `triGrow ${ms}ms linear forwards`;
        }
      });
    };

    const stop  = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => { stop(); timer = setInterval(() => activate(idx + 1), ms); };

    steps.forEach((s, j) => s.addEventListener('click', () => { activate(j); start(); }));
    tri.addEventListener('mouseenter', stop);
    tri.addEventListener('mouseleave', start);

    activate(0);
    start();
  }
    // --- ZIP checker (Brevard only) ---
  const zipWrap = section.querySelector('.zip-check');
  if (zipWrap){
    const input = zipWrap.querySelector('#bundle-zip');
    const btn   = zipWrap.querySelector('.js-zip-check');
    const out   = zipWrap.querySelector('.zip-result');
    const rawList = (section.dataset.brevard || '');
    // turn "32901, 32903, ..." into ['32901','32903',...]
    const zips = rawList.split(',').map(z => z.trim()).filter(Boolean);

    const show = (ok, zip) => {
      if (!out) return;
      out.classList.remove('ok','no');
      out.classList.add(ok ? 'ok' : 'no');
      if (ok){
        out.textContent = `Yes — we deliver to ${zip}!`;
      } else {
        out.innerHTML = `Sorry — ${zip} isn’t in our current delivery area. ` +
          `Join the waitlist below and we’ll notify you when we expand.`;
        // optional: scroll to the signup if it exists
        const sign = document.querySelector('.murphy-bundle .nationwide-signup');
        if (sign) sign.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    const normalize = (val) => (val || '').replace(/\D/g,'').slice(0,5); // keep 5 digits

    const runCheck = () => {
      const zip = normalize(input.value);
      input.value = zip; // reflect cleaned value
      if (zip.length !== 5) {
        show(false, zip || 'that ZIP');
        return;
      }
      show(zips.includes(zip), zip);
    };

    btn && btn.addEventListener('click', runCheck);
    input && input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); runCheck(); }
    });
  }
    /* Compare cards: simple per-card slider with arrows + touch swipe */
section.querySelectorAll('.sc-slider').forEach(slider => {
  const track  = slider.querySelector('.sc-track');
  const slides = Array.from(track ? track.children : []);
  const prev   = slider.querySelector('.sc-prev');
  const next   = slider.querySelector('.sc-next');
  let idx = 0;

  const update = () => {
    if (!track) return;
    track.style.transform = `translateX(-${idx * 100}%)`;
    if (prev) prev.disabled = idx === 0;
    if (next) next.disabled = idx === slides.length - 1;
  };

  if (slides.length > 1){
    prev && prev.addEventListener('click', ()=>{ if (idx > 0) { idx--; update(); } });
    next && next.addEventListener('click', ()=>{ if (idx < slides.length - 1) { idx++; update(); } });

    // touch swipe
    let startX = 0, delta = 0;
    slider.addEventListener('touchstart', e => { startX = e.touches[0].clientX; delta = 0; }, {passive:true});
    slider.addEventListener('touchmove',  e => { delta  = e.touches[0].clientX - startX; }, {passive:true});
    slider.addEventListener('touchend',   () => {
      if (Math.abs(delta) > 40){
        if (delta < 0 && idx < slides.length - 1) idx++;
        if (delta > 0 && idx > 0) idx--;
        update();
      }
      delta = 0;
    }, {passive:true});
  }
  update();
});
})();
